import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=0636deec&scoped=true&"
import script from "./ActionCard.vue?vue&type=script&lang=js&"
export * from "./ActionCard.vue?vue&type=script&lang=js&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=0636deec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636deec",
  null
  
)

export default component.exports